import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import { KpiLayout } from "components/OverviewPages/KPIs/KpiLayout";
import Tooltip from "@mui/material/Tooltip";

import { useLazyFetchGet } from "hooks/fetch/useLazyFetchGet";
import parseCost from "core/utils/parse_cost";

import { ReactComponent as SavingIcon } from "assets/img/KPIIcons/saving.svg";
import { styled } from "@mui/material/styles";

import { DEFAULT_DATE_TIME_FORMAT } from "core/datetime";

const oneYearAgo = () => {
  return moment()
    .subtract(1, "years")
    .format(DEFAULT_DATE_TIME_FORMAT);
};

export function FleetSavingsKpi({ expanded, fleet, site, machine }) {
  const [savings, setSavings] = useState();
  const oneYearAgoValue = useMemo(() => oneYearAgo(), []);

  const url = site?.id
    ? `cases/estimated_savings?date_time__gt=${oneYearAgoValue}&site_id=${site.id}`
    : machine?.id
    ? `cases/estimated_savings?date_time__gt=${oneYearAgoValue}&machine_id=${machine.id}`
    : `cases/estimated_savings?date_time__gt=${oneYearAgoValue}`;

  const { loading, getCallback } = useLazyFetchGet(url, ({ sum }) =>
    setSavings(sum ?? 0)
  );

  useEffect(() => {
    if (expanded && savings === undefined) {
      if (fleet || site || machine) {
        getCallback();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savings, expanded, fleet, site, machine]);

  return (
    <KpiLayout
      title="Savings"
      loading={loading || typeof savings !== "number"}
      Icon={SavingIcon}
      cursorEnable={false}
    >
      <Tooltip
        title="Estimated saving is calculated automatically based on the component associated with this case"
        aria-label="estimated-savings-tooltip"
      >
        <KpiBody>
          <span>$</span>
          {parseCost(savings)}
        </KpiBody>
      </Tooltip>
    </KpiLayout>
  );
}

const KpiBody = styled("div")`
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  height: 48px;
  color: #485057;
`;

FleetSavingsKpi.propTypes = {
  expanded: PropTypes.bool.isRequired,
  fleet: PropTypes.bool,
  site: PropTypes.object,
  machine: PropTypes.object
};
